import * as React from 'react';
import { createPortal } from 'react-dom';

/**
 * Calendar shell shared by DatePicker and DateRangePicker. Normally portaled
 * into document.body; inline keeps modal calendars in their focus trap.
 */
export function CalendarPopover({
  open,
  popoverRef,
  style,
  children,
  inline = false,
}: {
  open: boolean;
  popoverRef: React.RefObject<HTMLDivElement | null>;
  style: React.CSSProperties;
  children: React.ReactNode;
  inline?: boolean;
}) {
  if (!open) return null;
  const content = (
    <div
      ref={popoverRef}
      data-ui-popover
      style={inline ? undefined : style}
      className={
        inline
          ? 'relative animate-fade-in rounded-xl border-2 border-border bg-card shadow-hard [&_th]:w-8 [&_td>button]:size-8 [&_button]:focus-visible:ring-2 [&_button]:focus-visible:ring-ring'
          : 'animate-fade-in rounded-xl border-2 border-border bg-card shadow-hard'
      }
    >
      {children}
    </div>
  );
  return inline ? content : createPortal(content, document.body);
}
